/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// useEffectの中で実行すると初回描画時のみ(componentDidMount) になる
export const useDidMount = (func) =>
  useEffect(() => {
    func();
  }, []);

// useEffectでreturnされた関数はクリーンアップ(componentWillUnMount)になる
export const useWillUnMount = (func) => useEffect(() => func, []);

export const useNavigateWithId = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const currentId = searchParams.get('id');

  const navigateWithId = (to, options = {}) => {
    // 数値（履歴移動）の場合はそのまま navigate
    if (typeof to === 'number') {
      return navigate(to, options);
    }

    // 1. 文字列からURLオブジェクトを作成（相対パス対応のため origin を付与）
    const url = new URL(to, window.location.origin);

    // 2. 現在のURLに id があれば、遷移先のクエリパラメータに追加
    if (currentId && !url.searchParams.has('id')) {
      url.searchParams.set('id', currentId);
    }

    // 3. path + search (+ hash) を結合して navigate
    // url.pathname ... "/test"
    // url.search   ... "?id=123&other=abc"
    navigate(url.pathname + url.search + url.hash, options);
  };

  return navigateWithId;
};